import { useUploadQueue } from '@hooks/useUploadQueue';
import { Progress } from '@components/ui/progress';
import { useTranslation } from 'react-i18next';
import { Check, X } from 'lucide-react';

export const UploadQueue = () => {
  const { uploads } = useUploadQueue();
  const { t } = useTranslation('app');

  if (!uploads.length) return null;

  return (
    <div className="pointer-events-none fixed bottom-4 left-4 z-[90] flex w-full max-w-[320px] flex-col gap-2">
      {uploads.map(({ id, label, progress, status }) => (
        <div
          key={id}
          className="pointer-events-auto flex flex-col gap-2 rounded-md border border-neutral-100 bg-white p-3 shadow-lg">
          <div className="flex items-center justify-between gap-2 text-sm text-neutral-700">
            <span className="truncate">{label}</span>
            {status === 'success' && <Check className="h-4 w-4 shrink-0 text-success-500" />}
            {status === 'error' && <X className="h-4 w-4 shrink-0 text-danger-500" />}
          </div>
          <Progress
            value={progress}
            bar={status === 'error' ? 'bg-danger-500' : 'bg-neutral-900'}
          />
          <span className="text-xs text-neutral-500">
            {status === 'uploading' && t('fileUpload.queue.uploading', { progress })}
            {status === 'success' && t('fileUpload.queue.success')}
            {status === 'error' && t('fileUpload.queue.error')}
          </span>
        </div>
      ))}
    </div>
  );
};
